import { ItemTypeEnum } from '../enums/item-type.enum';
import { IBreadcrumb } from '../interfaces/ibreadcrumb-item.interface';

export class Breadcrumb implements IBreadcrumb {
    label: string;
    url: string;
    name: string;
    folderId: number;


    public constructor(passedLabel: string, passedURL: string, passedFolderID: number) {
        this.label = passedLabel;
        this.url = passedURL;
        this.folderId = passedFolderID;
        this.name = passedLabel;
    }

    public getParentId(): number {
        throw new Error('Method not implemented.');
    }

    public getId(): number {
        return this.folderId;
    }

    public getType(): string {
        return ItemTypeEnum.BREADCRUMB;
    }
}
